export const TRANSACTION_TYPE_OPTIONS = ['Upwork', 'PayPal', 'Bank', 'Google Pay', 'Cash', 'Razorpay'];

export const CUSTOM_OPTION_VALUE = '__custom__';

